export const availableCurrencies = ['EUR', 'USD', 'VND', 'SEK', 'CZK', 'PLN', 'CHF'];

export function currencyUnit(currency: string) {
  switch (currency) {
    case 'EUR': {
      return 100;
    }
    case 'USD': {
      return 100;
    }
    case 'VND': {
      return 1;
    }
    case 'SEK': {
      return 100;
    }
    case 'CZK': {
      return 100;
    }
    case 'PLN': {
      return 100;
    }
    case 'CHF': {
      return 100;
    }

    default: {
      return 1;
    }
  }
}

function getCurrencyLocale(currency: string): string {
  const localeMap: Record<string, string> = {
    EUR: 'de-DE',
    USD: 'en-US',
    VND: 'vi-VN',
    SEK: 'sv-SE',
    CZK: 'cs-CZ',
    PLN: 'pl-PL',
    CHF: 'de-CH',
  };
  return localeMap[currency] || 'en-US';
}

export function currencySymbol(currency: string) {
  return (
    Intl.NumberFormat(getCurrencyLocale(currency), {
      style: 'currency',
      currency: currency,
    })
      .formatToParts(1)
      .find((x) => x.type === 'currency')?.value ?? ''
  );
}

export function formatCurrency(value: number | null, currency: string): string {
  if (value == undefined) {
    return 'N/A';
  }

  const unit: number = currencyUnit(currency);

  return new Intl.NumberFormat(getCurrencyLocale(currency), {
    style: 'currency',
    currency: currency,
  }).format(value / unit);
}

export function formatRawCurrency(value: number | null, currency: string): { value: string; symbol: string } {
  if (value == undefined) {
    return { value: '0', symbol: currencySymbol(currency) };
  }

  const unit: number = currencyUnit(currency);

  return {
    value: Intl.NumberFormat(getCurrencyLocale(currency)).format(value / unit),
    symbol: currencySymbol(currency),
  };
}

export function normalizeCurrency(value: string, currency: string) {
  if (!value) {
    return 0;
  }

  const unit: number = currencyUnit(currency);
  return Math.round(parseFloat(value) * unit);
}
